module.exports = __webpack_public_path__ + "img/concrete_light_grey_ba_list.eb20da77.jpg";